import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  warningIcon: {
    fontSize: '3rem',
    color: theme.custom.darkOrange,
  },
  description: {
    fontSize: 17,
    fontWeight: 400,
    color: theme.custom.darkBlue,
    textAlign: 'center',
  },
}));
